import { Button, ButtonProps } from '@chakra-ui/react';
import { HelivanColor } from './HelivanColor';

interface HelivanButtonProps extends ButtonProps {
  variant: 'primary' | 'outline' | 'ghost' | 'action' | 'green';
}

export const HelivanButton = ({ ...props }: HelivanButtonProps) => {
  let px = 4;
  let py = 2;
  let buttonColor: string | undefined = '#114471';
  let textColor = 'white';
  let fontWeight = 500;
  let border: string | undefined = '1px solid #1F579C';
  let hoverBackground: string | undefined = '#486884';
  let hoverBorder: string | undefined = '1px solid #1F579C';
  let hoverTextColor = undefined;
  let borderRadius = undefined;

  if (props.variant === 'action') {
    borderRadius = '20px';
    buttonColor = '#114471';
    px = 3;
    py = 3;
    textColor = 'white';
    hoverBackground = '#486884';
  }
  if (props.variant === 'outline') {
    buttonColor = HelivanColor.background.primary;
    border = '1px solid #465369';
    textColor = HelivanColor.text.blueDark;
    hoverBorder = '1px solid #233b62';
    hoverBackground = undefined;
  }
  if (props.variant === 'ghost') {
    buttonColor = undefined;
    border = undefined;
    textColor = HelivanColor.text.blueMid;
    hoverBorder = undefined;
    hoverBackground = '#F6F7F9';
    hoverTextColor = HelivanColor.text.black;
  }
  if (props.variant === 'green') {
    buttonColor = HelivanColor.text.helivanBlue;
    border = undefined;
    hoverBackground = '#003d6b';
    textColor = 'white';
    hoverBorder = undefined;
    borderRadius = '10px';
    fontWeight = 600;
    px = 4;
    py = 1;
  }

  const isGreen = props.variant === 'green';

  return (
    <Button
      transition="all 0.15s"
      px={px}
      py={py}
      height={isGreen && props.size === 'sm' ? '34px' : undefined}
      color={textColor}
      backgroundColor={buttonColor}
      boxShadow={isGreen ? '0 1px 3px rgba(0,71,125,0.3)' : undefined}
      _hover={{
        backgroundColor: hoverBackground,
        border: hoverBorder,
        textColor: hoverTextColor,
        transform: isGreen ? 'translateY(-1px)' : undefined,
        boxShadow: isGreen ? '0 3px 8px rgba(0,71,125,0.35)' : undefined,
      }}
      _active={isGreen ? { transform: 'scale(0.98)' } : undefined}
      fontWeight={fontWeight}
      border={border}
      borderRadius={borderRadius}
      {...props}
    >
      {props.children}
    </Button>
  );
};
